import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

const EventDetails = observer(({uiState}) => {
  const {interviewSchedule, locationView, interviewersView} = uiState.interviewInvite;
  const {duration, eventDescription} = interviewSchedule;

  return (
    <>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'people'}</i>
        {interviewersView}
      </div>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'schedule'}</i>
        <FormattedMessage
          id='recruiting.schedule_interview.DURATION'
          values={{hours: Math.floor(duration / 60), minutes: duration % 60}}
        />
      </div>
      <div className='flex'>
        <i className='material-icons align-middle mr1'>{'place'}</i>
        {locationView}
      </div>
      {eventDescription && <span className='whitespace-pre-wrap jumbo'>{eventDescription}</span>}
    </>
  );
});

export default EventDetails;
